import { showPhoneNumberInString } from '../../../../../../common/utils/common';
import { UtilityService } from '../../../../../../common/services/Utility.service';

export class ContactsConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên khách hàng',
        key: 'display_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Số điện thoại',
        key: 'display_phone',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Email',
        key: 'display_email',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Nguồn',
        key: 'display_source',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổ chức',
        key: 'display_organize',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Nhóm khách hàng',
        key: 'display_group',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thành phố',
        key: 'display_city',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời gian khởi tạo',
        key: 'display_created_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static displayCodeColumns = item => {
    return `<a class="text_link" href="javascript:void(0)">${item.code}</a>`;
  };
  static displayNameColumns = (item, user) => {
    return item.name ? showPhoneNumberInString(item.name, user) : 'Chưa xác định';
  };
  static displayPhoneColumns = (item, user) => {
    return item.phone ? showPhoneNumberInString(item.phone.toString(), user) : 'Chưa xác định';
  };
  static displayEmailColumns = item => {
    return item.email ? item.email : 'Chưa xác định';
  };
  static displayOrganizeColumns = item => {
    return item.organize ? item.organize.text : 'Chưa xác định';
  };
  static displayGroupColumns = item => {
    return item.group ? item.group.text : 'Chưa xác định';
  };
  static displayCityColumns = item => {
    return item.city ? item.city.text : 'Chưa xác định';
  };
  static displaySourceColumns = item => {
    switch (item.source) {
      case 'call':
        if (item.source_detail == 'CALL_INBOUND') {
          return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
        }
        if (item.source_detail == 'CALL_OUTBOUND') {
          return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
        }
        break;
      case 'CALL_INBOUND':
        return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
      case 'CALL_OUTBOUND':
        return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
      case 'email':
        return `<i class="icon fa fa-envelope"></i>`;
      case 'web':
        return `<i class="icon fa fa-comments"></i>`;
      case 'hand':
        return `<i class="icon fa fa-edit"></i>`;
      case 'facebook':
        return `<i class="icon fa fa-facebook"></i>`;
      case 'zalo':
        return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
      default:
        return 'Chưa xác định';
    }
  };
  static displayTimeColumns = time => {
    return UtilityService.dateFormat(time);
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/organize/contacts/contacts.const.ts